import type { ExampleIconAliases } from './icons';

const aliases: ExampleIconAliases = {
  dark: 'fas fa-moon',
  light: 'fas fa-sun',
  ltr: 'fas fa-align-left',
  rtl: 'fas fa-align-right',
  palette: 'fas fa-palette',
  settings: 'fas fa-gear',
  formatText: 'fas fa-text',
  formOnly: 'fas fa-window-restore',
  reload: 'fas fa-rotate-right',
  save: 'fas fa-floppy-disk',
};

export { aliases };
